module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAWBAMAAAAlTTH8AAAAAXNSR0IB2cksfwAAAA9QTFRFAAAA////////////////j0LeaAAAAAV0Uk5TAGDv//B1amlBAAAAVElEQVR4nGNgQAZCiihcRmMjFL6wsQmqtLEhqrSxANWlYU6CSTtDKLhuZwgN1w1hIAyHsJAMBzGR7QaxUewGclCcxgjiIztNGM3ljKjSDAwijnAmAM3HEACac0xIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/compose-success-icon@2x.png
// module id = 794
// module chunks = 0